import { httpInstance } from '@/services/httpInstance';

const createReferralService = async (dataParam) => {
  let res;
  const endpoint = '/referrals/v1/promos/1';
  const dataSent = dataParam;

  await httpInstance.post(
    endpoint,
    dataSent,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default createReferralService;
